import React, { Component } from "react";
// import _ from 'lodash';
import IconButton from "material-ui/IconButton";
import Menu, { MenuItem } from "material-ui/Menu";
import MoreVertIcon from "material-ui-icons/MoreVert";

const STATUSES = {
  accepted: "Accepted",
  pending: "Pending",
};

const buttonStyles = {
  display: "block",
  margin: "auto",
  background: "none",
  border: "none",
  color: "#2d98de",
  textDecoration: "underline",
};

class GroupMembersItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleCancelInvitaion = () => {
    const { groupInvite, cancelInvitation } = this.props;
    cancelInvitation(groupInvite.id);
  };

  render() {
    const { groupInvite, handleApprove } = this.props;
    const { user, email } = groupInvite || {};
    const { anchorEl } = this.state;
    // const is_checked = _.includes(this.props.studygroup_ids, groupInvite.id);

    const isPending = groupInvite.status === "pending";

    return (
      <tr>
        {/* <td>
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id={`filled-in-box-${groupInvite.id}`}
              checked={is_checked}
              onChange={() => this.props.checkedStudygroupIds(group.id)}
            />
            <label htmlFor={`filled-in-box-${group.id}`} />
          </p>
        </td> */}
        <td style={{ textAlign: "center" }}>
          {user
            ? `${user.first_name} ${user.last_name}`
            : "The user is not in the system yet"}
        </td>
        <td style={{ textAlign: "center" }}>{email}</td>
        <td>
          {isPending && (
            <button
              style={buttonStyles}
              onClick={() => handleApprove(groupInvite.id)}
            >
              Accept Invitation
            </button>
          )}
        </td>
        <td>
          {isPending && (
            <button style={buttonStyles} onClick={this.handleCancelInvitaion}>
              Cancel Invitation
            </button>
          )}
        </td>
        <td style={{ textAlign: "center" }}>{STATUSES[groupInvite.status]}</td>
        <td>
          <button style={buttonStyles} onClick={this.handleCancelInvitaion}>
            Remove
          </button>
        </td>
      </tr>
    );
  }
}

GroupMembersItem.defaultProps = {};

GroupMembersItem.propTypes = {};

export default GroupMembersItem;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/GroupMembers/GroupMembersItem.jsx